import { Component } from '@angular/core'
import { IonicPage, NavController, NavParams, ViewController } from 'ionic-angular'
import { Subscription } from 'rxjs/Subscription'
import { Contact } from '../../models/models'
import { AddContactPage } from '../add-contact/add-contact';
import { ContactProvider } from '../../providers/api/contacts.provider';
import { ContactDetailPage } from '../contact-detail/contact-detail';

@IonicPage()
@Component({
  selector: 'page-contact-list',
  templateUrl: 'contact-list.html',
})
export class ContactListPage {

  myInput: string = ''
  contacts: Contact[]
  recentContacts: Contact[]
  hotContacts: Contact[]
  searchSubscription: Subscription
  modal = false
  nextHotUrl: string = null
  nextRecentUrl: string = null
  nextAllUrl: string = null
  tab = 'HOT'
  isLoading = true

  constructor(public navCtrl: NavController, public navParams: NavParams, public viewCtrl: ViewController, private contactProvider: ContactProvider) {
    if (this.navParams.get('modal')) {
      this.modal = true
    }
    this.getData()
  }

  reset() {
    this.hotContacts = []
    this.nextHotUrl = ""
    this.recentContacts = []
    this.nextRecentUrl = ""
    this.contacts = []
    this.nextAllUrl = ""
  }

  getData() {
    this.isLoading = true

    this.contactProvider.getHotContacts().subscribe(contacts => {
      this.hotContacts = contacts.results
      this.nextHotUrl = contacts.next
      this.isLoading = false
    })

    this.contactProvider.getRecentContacts().subscribe(contacts => {
      this.recentContacts = contacts.results
      this.nextRecentUrl = contacts.next
      this.isLoading = false
    })

    this.searchSubscription = this.contactProvider.getContacts().subscribe(contacts => {
      this.contacts = contacts.results
      this.nextAllUrl = contacts.next
      this.isLoading = false
    })
  }

  refresh() {
    this.reset()
    this.getData()
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ContactListPage');
  }

  close() {
    this.viewCtrl.dismiss(null)
  }

  selectContact(contact) {
    if (this.modal) {
      this.viewCtrl.dismiss(contact);
    } else {
      this.navCtrl.push(ContactDetailPage, {
        contact: contact,
        parent: this
      })
    }
  }

  onInput(_e) {

    this.isLoading = true
    if (this.searchSubscription) {
      this.searchSubscription.unsubscribe()
    }
    this.searchSubscription = this.contactProvider.getContacts(this.myInput).subscribe(
      x => {
        this.contacts = x.results

        this.isLoading = false
      }
    )
  }

  onCancel(_e) {
    this.isLoading = false
  }

  addContact() {
    this.navCtrl.push(AddContactPage)
  }


  nextHot(event) {
    if (!this.nextHotUrl) {
      event.complete()
      event.enable(false)
      return
    }

    this.contactProvider.getNextContacts(this.nextHotUrl).subscribe(
      page => {
        this.hotContacts.push(...page.results)
        this.nextHotUrl = page.next
      },
      e => { console.log(e) },
      () => { if (event !== null) event.complete() }
    )
  }

  nextRecent(event) {
    if (!this.nextRecentUrl) {
      event.complete()
      event.enable(false)
      return
    }

    this.contactProvider.getNextContacts(this.nextRecentUrl).subscribe(
      page => {
        this.recentContacts.push(...page.results)
        this.nextRecentUrl = page.next
      },
      e => { console.log(e) },
      () => { if (event !== null) event.complete() }
    )
  }

  nextAll(event) {
    if (!this.nextAllUrl) {
      event.complete()
      event.enable(false)
      return
    }

    this.contactProvider.getNextContacts(this.nextAllUrl).subscribe(
      page => {
        this.contacts.push(...page.results)
        this.nextAllUrl = page.next
      },
      e => { console.log(e) },
      () => { if (event !== null) event.complete() }
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/contact-list/contact-list.ts